var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2442_3206)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0.140625C11.4464 0.140625 13.6613 1.13228 15.2645 2.73551C16.8677 4.33874 17.8594 6.55362 17.8594 9C17.8594 11.4464 16.8677 13.6613 15.2645 15.2645C13.6613 16.8677 11.4464 17.8594 9 17.8594C6.55362 17.8594 4.33874 16.8677 2.73551 15.2645C1.13228 13.6613 0.140625 11.4464 0.140625 9C0.140625 6.55362 1.13228 4.33874 2.73551 2.73551C4.33874 1.13228 6.55362 0.140625 9 0.140625ZM6.13009 8.1907C5.89711 8.1907 5.70821 8.3796 5.70821 8.61258V12.5156C5.70821 12.7486 5.89711 12.9375 6.13009 12.9375H11.8699C12.1029 12.9375 12.2917 12.7486 12.2917 12.5156V8.61258C12.2917 8.3796 12.1029 8.1907 11.8699 8.1907H11.316V7.04848C11.316 6.5019 11.0927 6.00532 10.733 5.64557C10.3732 5.28581 9.87662 5.0625 9.33005 5.0625H8.66995C8.12338 5.0625 7.6268 5.28581 7.26704 5.64553C6.90732 6.00525 6.68401 6.50187 6.68401 7.04844V8.19067L6.13009 8.1907ZM7.52773 8.1907H10.4723V7.04848C10.4723 6.73481 10.3436 6.44934 10.1364 6.24213C9.92918 6.03489 9.64371 5.90625 9.33005 5.90625H8.66995C8.35629 5.90625 8.07082 6.03489 7.86361 6.2421C7.6564 6.44931 7.52776 6.73478 7.52776 7.04844V8.1907H7.52773Z",
    fill: "#7A7B93"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2442_3206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockIcon);
export default __webpack_public_path__ + "static/media/BlockIcon.bbc9fd59bba6d4ecfdd6f3299cdb057e.svg";
export { ForwardRef as ReactComponent };